import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export function useLabelMap() {
  const { t } = useTranslation();
  return useCallback(
    <V extends string>(values: readonly V[], key: (value: V) => string): Record<V, string> =>
      Object.fromEntries(values.map((value) => [value, t(key(value))])) as Record<V, string>,
    [t],
  );
}
